import React, { useState, useEffect } from "react";
import { Alert, Card } from "react-bootstrap";
import axios from "axios";
import { API } from "../../api";

function Comments(props) {
  const [comments, setComments] = useState([]);
  const [name, setName] = useState("");
  const [comment, setComment] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    axios
      .get(`${API}comments/${props.match.params.id}/`)
      .then((res) => setComments(res.data))
      .catch((err) => {
        // console.log(err.response.data)
      });
  }, [props.match.params.id]);

  const handelComment = () => {
    if (String(name).trim().length > 0 && String(comment).trim().length > 0) {
      axios
        .post(`${API}comments/`, {
          name,
          comment,
          product: props.match.params.id,
        })
        .then((res) => {
          setComments([...comments, res.data]);
          setName("");
          setComment("");
        })
        .catch((err) => {
          // console.log(err.response.data);
        });
    } else {
      setError("Please Fill In All The Fields");
      setTimeout(() => {
        setError("");
      }, 2000);
    }
  };

  return (
    <div>
      <p className="h5">Comments Sections</p>
      <div className="my-3">
        <div className="form-floating mb-3">
          <input
            type="text"
            className="form-control"
            id="floatingInputX"
            placeholder="Username"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
          <label htmlFor="floatingInputX">Username</label>
        </div>
        <div className="form-floating mb-3">
          <textarea
            className="w-100 px-3 py-2"
            style={{ resize: "none" }}
            placeholder="Enter Your Comment...."
            rows="7"
            value={comment}
            onChange={(e) => {
              setComment(e.target.value);
            }}
          ></textarea>
        </div>
        <button className="btn btn-dark" onClick={handelComment}>
          Add Comment
        </button>
        <div className="mt-3">
          {error && <Alert variant="danger">{error}</Alert>}
        </div>
      </div>
      <div style={{ maxHeight: "400px", overflow: "auto" }}>
        <Card>
          <Card.Header className="h6 fw-bold">All Comments</Card.Header>
          <Card.Body className="px-3">
            {comments.length === 0 ? (
              <div>No Comments Yet. Be The First One To Comment.</div>
            ) : (
              comments.map((item, i) => {
                return (
                  <div key={item.id} className="shadow-lg my-3 pt-4 pb-2 px-3">
                    <p className="m-0">Name : {item.name}</p>
                    <p>Comment : {item.comment}</p>
                  </div>
                );
              })
            )}
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}

export default Comments;
